var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 4,
    fill: "#6184AD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9525 24.2778C24.6574 23.8068 25.2068 23.1373 25.5312 22.3541C25.8556 21.5708 25.9404 20.709 25.775 19.8775C25.6095 19.046 25.2012 18.2823 24.6017 17.6829C24.0022 17.0835 23.2384 16.6753 22.4069 16.51C21.5754 16.3447 20.7135 16.4297 19.9303 16.7542C19.1471 17.0788 18.4778 17.6283 18.0069 18.3332C17.536 19.0382 17.2847 19.867 17.2849 20.7147C17.2861 21.8511 17.7381 22.9405 18.5417 23.744C19.3452 24.5474 20.4348 24.9992 21.5711 25.0002C22.4189 25.0002 23.2476 24.7488 23.9525 24.2778Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1755 26.3432C21.6525 26.0249 20.0692 26.1679 18.6278 26.7539C17.1865 27.3398 15.9525 28.3422 15.0836 29.6328C14.2146 30.9234 13.7501 32.4438 13.7494 33.9997C13.7494 34.1986 13.8284 34.3894 13.9691 34.53C14.1097 34.6707 14.3005 34.7497 14.4994 34.7497H28.6444C28.8433 34.7497 29.0341 34.6707 29.1747 34.53C29.3154 34.3894 29.3944 34.1986 29.3944 33.9997C29.3973 33.2044 29.2746 32.4137 29.0307 31.6567C28.6675 30.4864 28.0327 29.4186 27.1782 28.5404C26.092 27.4264 24.6985 26.6614 23.1755 26.3432Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6248 25.375C28.8644 25.375 27.4373 23.9479 27.4373 22.1875C27.4373 20.4271 28.8644 19 30.6248 19C32.3852 19 33.8123 20.4271 33.8123 22.1875C33.8123 23.9479 32.3852 25.375 30.6248 25.375Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.77 27.0467C27.9327 27.1922 28.097 27.3354 28.2507 27.4929C29.2719 28.5426 30.0306 29.8188 30.4647 31.2174C30.6134 31.6779 30.723 32.15 30.7925 32.6289H35.4995C35.6984 32.6289 35.8891 32.5499 36.0298 32.4092C36.1704 32.2686 36.2495 32.0778 36.2495 31.8789C36.2479 30.3876 35.6547 28.9577 34.6002 27.9032C33.5456 26.8486 32.1158 26.2555 30.6245 26.2539C29.6191 26.2577 28.6333 26.5315 27.77 27.0467Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatlogo);
export default __webpack_public_path__ + "static/media/chatlogo.d55bbc28d719f289adb468c6513a0ac8.svg";
export { ForwardRef as ReactComponent };